import AdminProjects from './AdminProjects'

export default AdminProjects
